import type {NextRouter} from 'next/router';

type Props = {
  router: NextRouter;
};

const LanguageHeadTags = ({router}: Props) => {
  const {asPath, locale} = router;

  return (
    <>
      <link rel="alternate" hrefLang="en" href={process.env.NEXT_PUBLIC_PRODUCTION_APP_URL + '/en' + asPath} />
      <link rel="alternate" hrefLang="sv" href={process.env.NEXT_PUBLIC_PRODUCTION_APP_URL + '/sv' + asPath} />
      <link rel="alternate" hrefLang="x-default" href={process.env.NEXT_PUBLIC_PRODUCTION_APP_URL + asPath} />
      <link
        rel="canonical"
        href={process.env.NEXT_PUBLIC_PRODUCTION_APP_URL + '/' + locale + asPath}
        key="canonicalLink"
      />
    </>
  );
};

export default LanguageHeadTags;
